<template lang="html">
    <div>
        <div id="main" class="content">
            <div class="container">
                <article class="js-gallery post-1202 post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized tag-11 tag-22 tag-29">
                    <section class="post_content">
                        <header class="post_header">
                            <h1 class="post_title">{{detail.title}}</h1>
                        </header>
                        <div class="post-body js-gallery" v-html="detail.content"></div>
                        <div class="meta split split--responsive cf">
                            <div class="split__title">
                                <time datetime="2017-10-02 01:44">{{detail.date}}</time>&nbsp;&nbsp;
                                <span><router-link v-for="label in detail.label" :key="label.id" :to="{path:'/',query: {label_id: label.id}}" class="label">#{{label.name}}#</router-link></span>
                            </div>
                            <!--<div id="social-share"><span class="entypo-share"><i class="iconfont">&#xe614;</i>分享</span></div>-->
                            <!--<div class="slide">-->
                                <a class="btn-slide" title="switch down"><i class="iconfont">&#xe615;</i>折叠评论区</a>
                            <!--</div>-->
                        </div>
                    </section>
                </article>
            </div>
            <svg id="upTriangleColor" width="100%" height="40" viewBox="0 0 100 102" preserveAspectRatio="none">
                <path d="M0 0 L50 100 L100 0 Z"></path>
            </svg>
            <div id="panel">
                <div class="comment-area">
                    <section class="comments">
                        <div class="comments-main">
                            <div id="comments-list-title"><span>{{pageInfo.totalCount}}</span> 条评论<span class="count-tips">（只显示最新的20条）</span></div>
                            <div id="loading-comments">
                                <div class="host">
                                    <div class="loading loading-0"></div>
                                    <div class="loading loading-1"></div>
                                    <div class="loading loading-2"></div>
                                </div>
                            </div>
                            <ul class="commentwrap">
                                <li class="comment even thread-even depth-1" v-for="comment in comments">
                                    <div class="comment_body contents">
                                        <div class="profile">
                                            <a href=""><img src="static/images/9cc50a9e422fb1c89aebafeb959cef7a.jpg" class="gravatar"></a>
                                        </div>
                                        <div class="main shadow">
                                            <div class="commentinfo">
                                                <section class="commeta">
                                                    <div class="shang">
                                                        <h4 class="author"><a href="" target="_blank"><img src="static/images/9cc50a9e422fb1c89aebafeb959cef7a.jpg" class="gravatarsmall" >{{comment.commenter}}</a></h4>
                                                    </div>
                                                </section>
                                            </div>
                                            <div class="body">
                                                <p>{{comment.content}}</p>
                                            </div>
                                            <div class="xia info">
                                                <span><time datetime="2018-03-09">{{comment.date}}</time></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- #comment-## -->
                            </ul>
                            <!--<nav id="comments-navi">-->
                                <!--<a class="prev page-numbers" href="">-->
                                    <!--<</a>-->
                                <!--<a class='page-numbers' href="">1</a>-->
                                <!--<a class='page-numbers' href="">2</a>-->
                                <!--<a class='page-numbers' href="">3</a>-->
                                <!--<span aria-current='page' class='page-numbers current'>4</span>-->
                            <!--</nav>-->
                            <div id="respond" class="comment-respond">
                                <h6 id="replytitle" class="comment-reply-title"><a rel="nofollow" id="cancel-comment-reply-link" href="" style="display:none;">取消</a></h6>
                                <form action="javascript:void(0)" class="clearfix">
                                    <div class="clearfix"></div>
                                    <div class="author-info">
                                        <input type="text" name="commenter" placeholder="昵  称 : " v-model="commentForm.commenter" tabindex="1" title="Name (required)" />
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="comment-form-info">
                                        <div class="real-time-gravatar"> <img id="real-time-gravatar" src="static/images/d41d8cd98f00b204e9800998ecf8427e.png" alt="gravatar头像" /></div>
                                        <p class="input-row">
                                            <i class="row-icon"></i>
                                            <textarea class="text_area" rows="3" cols="80" name="comment" tabindex="4" placeholder="你不说两句吗？(°∀°)ﾉ……" v-model="commentForm.content"></textarea>
                                            <div id="loading" v-if="loading"></div>
                                            <input type="button" id="submit" name="submit" class="button" tabindex="5" value="发送" :disabled="loading" @click="commitComment"/>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <svg id="dwTriangleColor" width="100%" height="40" viewBox="0 0 100 102" preserveAspectRatio="none">
                <path d="M0 0 L50 100 L100 0 Z"></path>
            </svg>
            <div class="wrapper">
            </div>
        </div>

        <div class="navpost-part">
            <div id="NextPrevPosts">
                <div class="prev" data-aos="slide-right" data-aos-delay="1.5s" v-if="detail.prev.id > 0">
                    <div class="arrow"><i class="iconfont">&#xe625;</i></div>
                    <div class="preview">
                        <div class="pull-left featuredImg" style="background-image:url('../../static/images/b0ce3f3cde0c084b6d42321b2dcbc407.jpeg');"></div>
                        <router-link class="pull-left preview-content bold" :to="'/detail/' + detail.prev.id"><span>{{detail.prev.title}}</span></router-link>
                    </div>
                </div>
                <div class="next" data-aos="slide-left" data-aos-delay="1.5s" v-if="detail.next.id > 0">
                    <div class="arrow"><i class="iconfont">&#xe623;</i></div>
                    <div class="preview">
                        <div class="pull-right featuredImg" style="background-image:url('../../static/images/b0ce3f3cde0c084b6d42321b2dcbc407.jpeg');"></div>
                        <router-link class="pull-right preview-content bold" :to="'/detail/' + detail.next.id"><span>{{detail.next.title}}</span></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<link rel="stylesheet" type="text/css" href="../../static/css/detail.css" />

<script>
	export default {
		name: "detail",
        props: ['id'],
        data: function(){
            return {
                articleID: this.id,
                detail: {
                    title: "",
                    content: "",
                    date: "",
                    label: [],
                    prev:{},
                    next:{}
                },
                comments: [],
                pageInfo:{
                    totalCount: 0,    //总评论数
                    totalPage: 1,     //总评论页数
                },
                page: 1,     //当前页
                hasNext: true,      //是否有下一页
                loading: false,    //是否正在加载
                commentForm: {
                    commenter: "",
                    content:""
                }
            }
        },
        created: function(){
            this.getDetail();
            this.getArticleComment();
        },
        methods: {
            getDetail: function(){
                this.$http.get("/article/" + this.articleID, {}, (res) => {
                    if(res.status){
                        for (var key in res.data){
                            if(key in this.detail){
                                this.detail[key] = res.data[key];
                            }
                        }
                    }else{
                        console.log(res.msg);
                    }
                })
            },
            getArticleComment: function(){
                this.$http.get("/comment?article_id=" + this.articleID, {}, (res) => {
                    if(res.status){
                        this.comments = res.data;
                        this.pageInfo = res.page_info;
                    }else{
                        console.log(res.msg);
                    }
                })
            },
            commitComment: function(){
                if(!this.commentForm.commenter || !this.commentForm.content){
                    return false;
                }
                this.loading = true;
                let postData = {
                    id: this.articleID,
                    commenter: this.commentForm.commenter,
                    content: this.commentForm.content
                };
                this.$http.post("/comment", postData, (res) => {
                    if(res.status){
                        //初始化表单
                        this.commentForm.commenter = "";
                        this.commentForm.content = "";
                        this.getArticleComment();
                    }else{
                        console.log(res.msg);
                    }
                    this.loading = false;
                })
            },
            change: function(){
                this.$router.go(0);
            }
        }
	}
</script>
<style lang="css" scoped>
    .container {
        padding: 10px 0px;
    }
    .post {
        margin: 0 auto
    }
    .label {
        color: blue !important;
    }
    .count-tips {
        font-size: 13px;
        text-transform: uppercase;
        color: #A1A1A1;
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/pages/detail.vue